<script lang="ts">
	import type { Page } from '$models/Page/Page';
	import type { Snippet } from 'svelte';
	import { afterNavigate } from '$app/navigation';
	import { page as routePage } from '$app/state';
	import MainLayout from '$components/Layout/MainLayout.svelte';
	import Ribbon from '$components/Layout/Ribbon.svelte';
	import { getSiteContext } from '$lib/context/site';
	import { trackVirtualPageview } from '$lib/datalayer/datalayer';
	import { getFirstPanoramaPreloadLinks } from '$lib/pages';
	import { organizationDeHeadScriptHtml } from '$lib/seo/schemas/organizationDe';
	import { organizationNlHeadScriptHtml } from '$lib/seo/schemas/organizationNl';

	let { page, children }: { page: Page; children?: Snippet } = $props();
	const site = getSiteContext();
	let panoramaPreloadLinks = $derived(getFirstPanoramaPreloadLinks(page));

	let organizationSchemaHtml = $derived.by(() => {
		const ctx = { url: routePage.url, page, site };
		if (site.locale.language === 'nl') {
			return organizationNlHeadScriptHtml(ctx);
		}
		if (site.locale.language === 'de') {
			return organizationDeHeadScriptHtml(ctx);
		}
		return '';
	});

	afterNavigate(() => {
		if (page.metadata.title) {
			trackVirtualPageview(window.location.href, page.metadata.title);
		}
	});
</script>

{#if page.layout.ribbon.length > 0}
	<Ribbon ribbon={page.layout.ribbon} />
{/if}

<MainLayout {page}>
	{@render children?.()}
</MainLayout>

<svelte:head>
	{#if page.metadata.raw}
		{@html page.metadata.raw}
	{/if}

	{#if organizationSchemaHtml}
		{@html organizationSchemaHtml}
	{/if}

	{#each page.layout.meta.alternateLanguages as { language, link }}
		<link rel="alternate" hreflang={language} href={link} />
	{/each}

	{#each panoramaPreloadLinks as { href, media }}
		<link rel="preload" as="image" {href} {media} />
	{/each}
</svelte:head>
